class RaitooeFooter extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    const { signal } = this.controller;
    this.desktop = window.matchMedia('(min-width: 750px)');
    this.groups = [...this.querySelectorAll('.rt-footer__group')];
    const sync = () => {
      this.groups.forEach((group) => {
        group.open = this.desktop.matches;
        const heading = group.querySelector('summary');
        if (this.desktop.matches) heading.setAttribute('tabindex', '-1');
        else heading.removeAttribute('tabindex');
      });
    };
    this.desktop.addEventListener('change', sync, { signal });
    this.addEventListener('click', (event) => {
      if (this.desktop.matches && event.target.closest('.rt-footer__group > summary')) event.preventDefault();
    }, { signal });
    sync();
  }

  disconnectedCallback() {
    this.controller?.abort();
  }
}

if (!customElements.get('raitooe-footer')) customElements.define('raitooe-footer', RaitooeFooter);
